<template>
    <v-container class="week-schedule-list" fluid v-if="weekSchedule">
        <v-row v-for="i in Array(7).keys()">
            <v-col>
                <v-select outlined
                          :label="$t(`admin_acc_week_schedule.day_${i+1}`)"
                          :placeholder="$t(`admin_acc_week_schedule.day_${i+1}`)"
                          :items="dayScheduleOptions"
                          v-model="weekSchedule[`day_${i+1}`]"></v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-select outlined
                          :label="$t('admin_acc_week_schedule.public_holiday_schedule')"
                          :placeholder="$t('admin_acc_week_schedule.public_holiday_schedule')"
                          :items="dayScheduleOptions"
                          v-model="weekSchedule.public_holiday_schedule"></v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="text-right">
                <v-spacer></v-spacer>
                <v-btn text color="#2bc7ca"
                       @click="resetWeekSchedule">
                    {{ $t('reset') }}
                </v-btn>
                <v-btn text color="#2bc7ca"
                       @click="saveWeekSchedule">
                    {{ $t('save') }}
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {computed, onMounted, ref} from "@vue/composition-api";

    export default {
        name: 'WeekScheduleList',
        components: {},
        props: {
            typeId: String,
        },
        setup(props, {root}) {
            // Week Schedule
            const weekSchedule = ref(null);
            const getWeekSchedule = function () {
                root.$callAPI('room/admin/item_type/week_schedule/', {
                    type_id: props.typeId,
                }, function (response) {
                    weekSchedule.value = response.body.week_schedule || {
                        day_1: null,
                        day_2: null,
                        day_3: null,
                        day_4: null,
                        day_5: null,
                        day_6: null,
                        day_7: null,
                        public_holiday_schedule: null,
                    };
                });
            };
            const resetWeekSchedule = function () {
                getWeekSchedule();
            };
            const saveWeekSchedule = function () {
                root.$callAPI('room/admin/item_type/week_schedule/set/', {
                    type_id: props.typeId,
                    ...weekSchedule.value,
                }, function (response) {
                    getWeekSchedule();
                });
            };

            // Day Schedule
            const daySchedules = ref([]);
            const dayScheduleOptions = computed(() => {
                return daySchedules.value.map((s) => {
                    return {text: s.name, value: s};
                })
            });
            const dayScheduleMap = computed(() => {
                let map = {};

                daySchedules.value.forEach((s) => {
                    map[s.id] = s;
                });

                return map;
            });
            const getDaySchedules = function () {
                root.$callAPI('room/admin/item_type/day_schedule/', {
                    type_id: props.typeId,
                }, function (response) {
                    daySchedules.value = response.body.day_schedules;
                });
            };

            onMounted(() => {
                getWeekSchedule();
                getDaySchedules();
            })

            return {
                weekSchedule,
                dayScheduleOptions,
                dayScheduleMap,
                resetWeekSchedule,
                saveWeekSchedule,
            };
        },
    }
</script>